import axios from 'axios';
import { makeAutoObservable } from 'mobx'
import loginStore from './loginStore';
import { toast } from 'react-toastify';

class UserStore {

    users = []
    addNewUserModalVisible = false
    updateUserModalVisible = false
    currentUser = null

    constructor() {
        makeAutoObservable(this)
    }

    async setUsers(data) {
        this.users = data;
    }

    async createUser(user) {
        const formData = new FormData();

        formData.append('EmployeeName', `${user.employeeName}`);
        formData.append('Email', user.email);
        formData.append('Designation', user.designation.value);
        formData.append('LoggedInUser', loginStore.userData.loggedInUser);

        if (user.image) {
            formData.append('ProfileImage', user.image);
        }

        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(`/api/User/createUser`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    this.users.push(response.data.userList);
                    resolve(response.data);
                    toast.success(response.data.message);
                } else {
                    reject(response.data.message);
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                reject(error);
            }
        });
    }

    async updateUser(data) {
        try {
            return new Promise((resolve, reject) => {

                const params = {
                    empId: data.empId,
                    EmployeeName: data.employeeName,
                    Email: data.email,
                    Designation: data.designation,
                    LoggedInUser: loginStore.userData.loggedInUser
                }

                const formData = new FormData();
                formData.append('ProfileImage', data.profileImagePath);

                axios.post(`/api/User/updateUser`, formData, {
                    params: params,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then(response => {
                    if (response.data.status === true) {
                        const updatedUsers = this.users.map(user =>
                            user.empId === data.empId ? { ...user, ...response.data.data[0] } : user
                        );

                        this.users = updatedUsers;
                        
                        toast.success(response.data.message);
                        resolve(this.users);
                    } else {
                        toast.error(response?.data?.message);
                        resolve(false);
                    }
                }).catch(error => {
                    console.error(error);
                    reject(error);
                });
            });
        } catch (error) {
            console.error(error)
        }

    }

    async getUsers() {
        return new Promise((resolve, reject) => {
            try {
                axios.post('/api/User/getUser', null, {
                    params: {
                        loggedInUser: loginStore.userData.loggedInUser
                    }
                })
                    .then(async response => {
                        if (response.data) {
                            this.users = response.data.userList || []
                            resolve(this.users);
                        }
                    }).catch(error => {
                        console.error("Error", error);
                    });
            } catch (error) {
                console.error(error);

            }
        });

    }

    async deleteUser(userId, email) {
        return new Promise((resolve, reject) => {
            return (
                axios.delete(`/api/User/deleteUser`, {
                    data: {
                        loggedInUser: loginStore.userData.loggedInUser,
                        email: email
                    },
                    params: {
                        id: userId
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(async response => {
                    if (response.status === 200) {
                        let newArray = this.users.filter((user) => user.empId !== userId);
                        this.users = newArray

                        toast.success(response.data.message);
                        resolve(this.users);
                    }
                }).catch(error => {
                    reject(error);
                })
            )

        });

    }

    setAddNewUserModalVisible(bool) {
        this.addNewUserModalVisible = bool
    }

    setUpdateUserModalVisible(bool) {
        this.updateUserModalVisible = bool
    }

    setCurrentUser(user) {
        this.currentUser = user
    }
}

const userStore = new UserStore();
export default userStore